<div class="carousel-form">
  <span class="carousel-form__title fs__md fw__500">Cards</span>
  <ul class="carousel-form__options">
    @for (card of cards.controls; track card; let index = $index; let last = $last) {
      <li>
        <input
          class="carousel-form__options__input fs__md"
          #questionCards
          type="text"
          placeholder="Cards {{ index + 1 }}"
          [formControl]="card | toFormControl"
          [readonly]="disabled"
          (keyup.enter)="last ? addCard() : jumpCard(index)"
          (keydown.backspace)="deleteCard(index)"
          (keydown.arrowup)="jumpCard(index - 1)"
          (keydown.arrowdown)="jumpCard(index + 1)"
        />
      </li>
    }
  </ul>

  <span class="carousel-form__title fs__md fw__500">Options</span>
  <ul class="carousel-form__options">
    @for (option of options.controls; track option; let index = $index; let last = $last) {
      <li>
        <input
          class="carousel-form__options__input fs__md"
          #questionOptions
          type="text"
          placeholder="Option {{ index + 1 }}"
          [formControl]="option | toFormControl"
          [readonly]="disabled"
          (keyup.enter)="last ? addOption() : jumpOption(index)"
          (keydown.backspace)="deleteOption(index)"
          (keydown.arrowup)="jumpOption(index - 1)"
          (keydown.arrowdown)="jumpOption(index + 1)"
        />
      </li>
    }
  </ul>
</div>
